import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Leaflet from 'leaflet';
import greenMarker from '../../../../assets/images/Marker/greenMarker.png';
import redMarker from '../../../../assets/images/Marker/redMarker.png';
import blueMarker from '../../../../assets/images/Marker/blueMarker.png';
import DialogContentText from '@material-ui/core/DialogContentText';
import CardMedia from '@material-ui/core/CardMedia';



const ViewPicture = ({ fotoModal, handleClosePicture }) => {

    return (
        <>
            <DialogTitle style={{ textAlign: 'center', width: 600 }}>REGISTRO</DialogTitle>
            <DialogContent style={{ textAlign: '-webkit-center', width: '100%' }}>
                <DialogContentText>
                    {/* {this.state.namePicture} - {(moment(this.state.dataPicture, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy'))} - {this.state.typePicture == 'I' ? 'Entrada' : 'Saida'} - {this.state.hourPicture} */}
                </DialogContentText>
                <CardMedia
                    component="img"
                    image={fotoModal}
                    style={{ maxWidth: '90%', maxHeight: '70%', borderRadius: '20px' }}
                />
                <div style={{justifyContent: 'center', display: 'flex', marginTop: '40px'}}>
                    <Button
                        // onClick={creatTimesheet}
                        variant="contained" style={{ backgroundColor: '#4851de', color: 'white', borderRadius: '20px', height: '50px', width: '35%' }}>
                        Baixar foto
                    </Button>
                    <Button
                        variant="contained"
                        style={{
                            backgroundColor: 'white',
                            color: '#4851de',
                            borderRadius: '20px',
                            height: '50px',
                            width: '35%',
                            border: '1px solid #4851de',
                            marginLeft:'10px'
                        }}
                        onClick={handleClosePicture}>
                        Voltar
                    </Button>
                </div>
            </DialogContent>
            {/* <DialogActions style={{ justifyContent: 'center', display: 'flex', marginBottom: '20px' }}>

                <Button
                    // onClick={creatTimesheet}
                    variant="contained" style={{ backgroundColor: '#4851de', color: 'white', borderRadius: '20px', height: '50px', width: '35%' }}>
                    Baixar foto
                </Button>
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: 'white',
                        color: '#4851de',
                        borderRadius: '20px',
                        height: '50px',
                        width: '35%',
                        border: '1px solid #4851de'
                    }}
                    onClick={handleClosePicture}>
                    Voltar
                </Button>

            </DialogActions> */}
        </>
    )
}

export default ViewPicture;